import { calculateEnvironmentByHost } from '@cian/utils';

export const IDENTIFICATION_STATUS = {
  WAIT_FOR_CONFIRM: 'WAIT_FOR_CONFIRM',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  ERROR: 'ERROR',
};

export const USER_IDENTIFICATION_STATUS = {
  OK: 'okNoIdentificationNeeded',
  WAIT: 'notIdentified',
  NO: 'needIdentification',
  ERROR: 'ERROR',
  NEED_TO_DRAFT: 'needIdentificationSetToDraft',
  PROCESS_TO_DRAFT: 'notIdentifiedSetToDraft',
};
/**
 * Сервис для идентификации пользователя с проверкой паспорта через sumsub
 */
export default [
  '$q', '$http', 'addFormService', '$rootScope', 'analyticsService', 'popupService', '$interval', 'geoService',
  function ($q, $http, addFormService, $rootScope, analyticsService, popupService, $interval, geoService)
{
  let that = this;
  let _applicantId = null;
  let _accessToken = null;

  let isVisible = false;
  let isSelectPageVisible = false;
  let isUserNeedIdentification = false;

  let completeCallback = null;

  let userStatusByAd = null;
  let userRegionIdByAd = null;
  let isOnlyDraftEnabled = false;

  // Черновик в процессе сохранения
  let isSaveInProcess = false;

  let draftId = null;

  let identifitactionLink = '';

  let postDraftSaveCallback = null;

  that.userStatus = 'notIdentified';
  let taskList = [];

  const getIdentificationLink = () => {
    return identifitactionLink;
  }

  const setIdentificationLink = (link) => {
    identifitactionLink = link;
  }

  const getPostDraftSaveCallback = () => {
    return postDraftSaveCallback;
  }

  const setPostDraftSaveCallback = (callback) => {
    postDraftSaveCallback = callback;
  }

  const getApplicantId = () => {
    return _applicantId;
  };

  const setApplicantId = val => {
    _applicantId = val;
  };

  const getIsUserNeedIdentification = () => {
    return isUserNeedIdentification;
  };

  const setIsUserNeedIdentification = val => {
    isUserNeedIdentification = !!val;
  };

  const getDraftId = () => {
    return draftId;
  };

  const setDraftId = val => {
    draftId = val;
  };

  const setAccessToken = val => {
    _accessToken = val;
  };

  const getAccessToken = () => {
    return _accessToken;
  };

  const getIsSelectPageVisible = () => {
    return isSelectPageVisible;
  };

  const setIsSelectPageVisible = val => {
    isSelectPageVisible = !!val;
  };

  const getIsVisible = () => {
    return isVisible;
  };

  const setIsVisible = val => {
    isVisible = !!val;
  };

  const getIsOnlyDraftEnabled = () => {
    return isOnlyDraftEnabled;
  };

  const setIsOnlyDraftEnabled = val => {
    isOnlyDraftEnabled = !!val;
  };

  const getIsSaveInProcess = () => {
    return isSaveInProcess;
  };

  const setIsSaveInProcess = val => {
    isSaveInProcess = !!val;
  };

  const getUserStatusByAd = () => {
    return userStatusByAd;
  };

  const getUserRegionIdByAd = () => {
    return userRegionIdByAd;
  };

  const setTaskList = val => {
    taskList = val;
  }

  const getTaskList = () => {
    return taskList;
  }

  const setUserStatus = val => {
    that.userStatus = val;
  }

  const getUserStatus = () => {
    return that.userStatus;
  }

  const setCompleteCallback = ({success, error, expired}) => {
    completeCallback = {success, error, expired};
  };

  const getCompleteCallback = (type, params) => {
    return typeof completeCallback[type] === 'function' ? completeCallback[type](params) : null;
  };

  /**
   * Путь к API монолита
   * @returns {string}
   */
  const getAnnouncementsSumsubHost = () => {
    const environment = calculateEnvironmentByHost(window.location.host);
    let apiHost = '//master.announcements-sumsub.dev3.cian.ru/public';
    switch (environment) {
      case 'production':
        apiHost = '//api.cian.ru/announcements-sumsub';
        break;
      case 'beta':
        const betaName = window.location.host.match(/beta(\d+)/ig);
        apiHost = `//${betaName}.announcements-sumsub.stage.cian.ru/public`;
        break;
    }
    return apiHost;
  };

  /**
   * Путь к API идентификации
   * @returns {string}
   */
  const getIdentificationOrchestratorHost = () => {
    const environment = calculateEnvironmentByHost(window.location.host);
    let apiHost = 'http://master.identification-orchestrator.dev3.cian.ru/public';
    switch (environment) {
      case 'production':
        apiHost = 'https://api.cian.ru/identification-orchestrator';
        break;
      case 'beta':
        const betaName = window.location.host.match(/beta(\d+)/ig);
        apiHost = `https://${betaName}.identification-orchestrator.stage.cian.ru/public`;
        break;
    }
    return apiHost;
  };

  /**
   * Путь к API идентификации
   * @returns {string}
   */
  const getBillingAccountsHost = () => {
    const environment = calculateEnvironmentByHost(window.location.host);
    let apiHost = 'http://master.billing-accounts.dev3.cian.ru/public';
    switch (environment) {
      case 'production':
        apiHost = 'https://api.cian.ru/billing-accounts';
        break;
      case 'beta':
        const betaName = window.location.host.match(/beta(\d+)/ig);
        apiHost = `https://${betaName}.api.stage.cian.ru/billing-accounts`;
        break;
    }
    return apiHost;
  };

  /**
   * Получение доступных способов идентификации
   */
  const requestIdentificationServices = () => {
    const locationPath = geoService.getLocationPath();
    const headers = {
      'Cache-Control': undefined,
      'Pragma': undefined,
    };
    const params = {
      locationPath: `${locationPath[locationPath.length - 1]}`,
    };

    const res = $http.get(getIdentificationOrchestratorHost() + '/v1/get-identification-services-desktop/', { headers, withCredentials: true, params });

    return res;
  };

  /**
   * Получение текущего статуса идентификации
   */
  const requestIdentificationStatus = (data) => {
    const headers = {
      'Cache-Control': undefined,
      'Pragma': undefined,
    };

    $http.get(getIdentificationOrchestratorHost() + '/v1/get-identification-status/', { headers, withCredentials: true, params: { identificationServiceType: data } })
      .then(response => {
        if (response) {
          setUserStatus(response.data.status);
        }
      });
  };

  /**
   * Получение идентификационных данных пользователя в subsum-е
   */
  const requestIdentificationData = () =>
    $http.post(getAnnouncementsSumsubHost() + '/v1/add-applicant/', {}, { withCredentials: true });

  /**
   * Получение токена в subsum-е
   */
  const requestIdentificationAccessToken = () =>
    $http.post(getAnnouncementsSumsubHost() + '/v1/get-access-token/', {}, { withCredentials: true });

  /**
   * Отправили все документы в subsum, уведомляем монолит
   */
  const sentPassportIdentification = () =>
    $http.post(getAnnouncementsSumsubHost() + '/v1/edit-user-docs-sent/', {}, { withCredentials: true });

  /**
   *  Сбрасываем статус идентификации
   */
  const resetIdentificationServiceStatus = (identificationServiceType) =>
    $http.post(getIdentificationOrchestratorHost() + '/v1/reset-identification-service-status/', { identificationServiceType }, { withCredentials: true });

  /**
   *  Получаем URL редиректа для подтверждения карты
   */
  const postDepositAmountIdentification = () =>
    $http.post(getBillingAccountsHost() + '/v1/deposit-amount-identification/', {}, { withCredentials: true });

  const checkAvailableTasks = ($scope) => {
    const deferred = $q.defer();

    requestIdentificationServices()
      .then(response => {
        if (!!response.data.services.length) {
          setTaskList(response.data.services);
          if (response.data.services.length === 1) {
            onSelectIdentification(response.data.services[0]);
          } else {
            setIsSelectPageVisible(true);
          }
          if ($scope) {
            $scope.$apply();
          }
          deferred.resolve();
        } else {
          deferred.reject();
        }
      })
      .catch(e => {
        deferred.reject();
      });

    return deferred.promise;
  }

  const checkUserIdentification = () => {
    const deferred = $q.defer();

    $q.all([
      requestIdentificationAccessToken(),
      requestIdentificationData(),
    ])
      .then(response => {
        if (response && response[0] && response[0].data && response[1] && response[1].data) {
          setAccessToken(response[0].data.token);
          setApplicantId(response[1].data.applicantId);
          setIsVisible(true);
          deferred.resolve();
        } else {
          deferred.reject();
        }
      })
      .catch(e => {
        deferred.reject();
      });

    return deferred.promise;
  };

  /**
   * Опредяет, нужна ли пользователю для размещения объявления идентификация по паспорту (sumsub).
   */
  const markDraftAsNeedIdentification = (objectId) => {
    const ad = addFormService && addFormService.ad;
    const deferred = $q.defer();

    if (!ad) {
      deferred.resolve(false);
    } else {
      const params = {
        "objectId": objectId,
        "objectGuid": ad.objectGuid,
        "regionId": userRegionIdByAd,
      };

      $http({
        method: 'POST',
        url: `${getIdentificationOrchestratorHost()}/v1/mark-announcement-drafted-by-identification/`,
        headers: {'Content-Type': 'application/json'},
        data: params,
        allowServerErrors: true,
        withCredentials: true,
      })
        .then(successResponse => {
          deferred.resolve();
        })
        .catch(errorResponse => {
          deferred.reject();
        });
    }
    return deferred.promise;
  };

  /**
   * Сброс identificationRequest
   */
  let identificationRequest;

  const resetGosuslugiPromise = () => {
    $interval.cancel(identificationRequest);
  };

  /**
   * Выбор способа идентификации
   */
  function onSelectIdentification(task) {
    if (task.type === 'iframe') {
      setCompleteCallback({
        success: () => {
          analyticsService.finishIdentification();
          sentPassportIdentification();
          $rootScope.$emit('callShowPublishSuccess');
        },
        error: (e) => {
          popupService.openPopup('identificationError', {
            onClick: () => onSelectIdentification(task),
          });
          throw new Error(e);
        },
        expired: () => onSelectIdentification(task),
      });

      checkUserIdentification()
        .then(() => {
          setIsSelectPageVisible(false);
          setIsVisible(true);
        })
        .catch(() => {
          popupService.openPopup('identificationError', {
            onClick: () => onSelectIdentification(task),
          });
        });
    } else if (task.type === 'bankCard') {
      postDepositAmountIdentification()
        .then(({ data }) => {
          if (data && data.redirectUrl) {
            window.open(data.redirectUrl, '_self');
          }
        })
    } else {
      window.open(task.iframeUrl);
      resetIdentificationServiceStatus(task.identificationServiceType).then(() => {
        identificationRequest = $interval(requestIdentificationStatus, 2000, 150, true, task.identificationServiceType);
      });
    }
  }

  return {
    IDENTIFICATION_STATUS: IDENTIFICATION_STATUS,
    USER_IDENTIFICATION_STATUS: USER_IDENTIFICATION_STATUS,
    getUserStatusByAd: getUserStatusByAd,
    getUserRegionIdByAd: getUserRegionIdByAd,
    getDraftId: getDraftId,
    setDraftId: setDraftId,
    getApplicantId: getApplicantId,
    getAccessToken: getAccessToken,
    getIsSelectPageVisible: getIsSelectPageVisible,
    setIsSelectPageVisible: setIsSelectPageVisible,
    getIsVisible: getIsVisible,
    setIsVisible: setIsVisible,
    getIsSaveInProcess: getIsSaveInProcess,
    setIsSaveInProcess: setIsSaveInProcess,
    getIsOnlyDraftEnabled: getIsOnlyDraftEnabled,
    setIsOnlyDraftEnabled: setIsOnlyDraftEnabled,
    getIsUserNeedIdentification: getIsUserNeedIdentification,
    setIsUserNeedIdentification: setIsUserNeedIdentification,
    getCompleteCallback: getCompleteCallback,
    setCompleteCallback: setCompleteCallback,
    checkUserIdentification: checkUserIdentification,
    sentPassportIdentification: sentPassportIdentification,
    markDraftAsNeedIdentification: markDraftAsNeedIdentification,
    getIdentificationLink: getIdentificationLink,
    setIdentificationLink: setIdentificationLink,
    requestIdentificationServices: requestIdentificationServices,
    requestIdentificationStatus: requestIdentificationStatus,
    setTaskList: setTaskList,
    getTaskList: getTaskList,
    checkAvailableTasks: checkAvailableTasks,
    getUserStatus: getUserStatus,
    setUserStatus: setUserStatus,
    userStatus: that.userStatus,
    resetIdentificationServiceStatus: resetIdentificationServiceStatus,
    onSelectIdentification: onSelectIdentification,
    resetGosuslugiPromise: resetGosuslugiPromise,
    setPostDraftSaveCallback: setPostDraftSaveCallback,
    getPostDraftSaveCallback: getPostDraftSaveCallback,
  };
}];
